import { render, staticRenderFns } from "./BaseCardHeader.vue?vue&type=template&id=0943bb48&"
import script from "./BaseCardHeader.vue?vue&type=script&lang=js&"
export * from "./BaseCardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports